import type { TransactionItemDetail } from 'models';
import { TransactionAnonymous } from './transaction-anonymous';
import { TransactionAvatarWrapper } from './transaction-avatar-wrapper';

export type TransactionViewBasedOnUserDisplayMode = 'detailed' | 'simple';

type P = {
  displayMode?: TransactionViewBasedOnUserDisplayMode;
  transaction: TransactionItemDetail;
};

const TransactionViewBasedOnUser = ({ displayMode, transaction }: P) => {
  const user = transaction.transaction?.user;

  if (user) {
    return (
      <TransactionAvatarWrapper
        displayMode={displayMode}
        key={transaction.id}
        transactionItem={transaction}
        user={user}
      />
    );
  }

  return <TransactionAnonymous displayMode={displayMode} key={transaction.id} transactionItem={transaction} />;
};

export default TransactionViewBasedOnUser;
